// extracted by mini-css-extract-plugin
module.exports = {"host":"DonationsChart_host__3D2aK","progressbar":"DonationsChart_progressbar__1_eCG"};